import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import { TablePaginationActionsWrapped } from '../../../Helper/Pagination/pagination';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { fetchVisitorsAction,GetCheckInData,GetDealClaimedData } from '../../../Actions/overviewActions';
import moment from 'moment';
import Loader from '../../../Helper/loader/loader';
import './visitors.css';
const styles=theme=>({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
  progress: {
    margin: theme.spacing.unit * 2,
  },
    table: {
        minWidth: 200,
    },
    tableRow: {
      height:52,
      backgroundColor:'white !important',
      fontSize:'15px'
    },
    tablefooter:{
        fontSize:'16px',
    },

  page:{
      fontSize:'14px',
      // paddingLeft:'710px',
  },
  time:{
      width:'90%'
  },
  dealPaper: {
    position: 'absolute',
    width: '60%',
    // fontSize:'15em',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
    btnClickable:{
        minHeight: '52px',
        textDecoration: 'underline',
        color: '#a435a6',
        fontSize: '14px',
        background:'unset',
        border:'none'
    },
    btnNormal:{
        minHeight: '52px',
        cursor:'auto',
        color: '#a435a6',
        fontSize: '14px',
        background:'unset',
        border:'none',
      '&active':{
          border:'none'
      }
    },
  dealTable:{
      fontSize:'15px',
    padding:0
  }
});

class VisitorsTable extends React.Component {
    constructor(props){
        super(props);
        this.state={
            open:false,
            page:0,
          mpage:0,
            mrowsPerPage:2,
            rowsPerPage:10,
            modalType:'',
          userName:'',
          DateTime:[],
        }
    }

    componentDidMount(){
        this.props.fetchVisitorsAction(this.props.user.BusinessUser.PlaceID,this.props.user.AppUser.UserId).then(()=>{
          // console.log('visiors data--',data.results.Result.sort((a,b)=>{
          //   let dateA=moment(moment.utc(a.LastCheckInDate).toDate()).local().format('MMM Do, YYYY'),
          //     dateB=moment(moment.utc(b.LastCheckInDate).toDate()).format('MMM Do, YYYY');
          //   return dateB-dateA;
          // }))
        });
        this.interval= setInterval(()=>{
                this.props.fetchVisitorsAction(this.props.user.BusinessUser.PlaceID);
            }, 500000
        );
    }

    componentWillUnmount(){
        clearInterval(this.interval);
        this.setState({open:false});
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleModalPageChange=(event,mpage)=>{
      this.setState({ mpage })
    }

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleModalChangeRowsPerPage = event => {
    this.setState({ mrowsPerPage: event.target.value });
  };

    handleOpen = (e) => {
      const {user}=this.props;
        let self = this;
        if(e.target.innerHTML!=="0" && e.target.name) {

            if (e.target.name === 'checkIn') {
              this.props.GetCheckInData(user.BusinessUser.PlaceID, e.target.id.split(",")[0]);
              self.setState({
                modalType: 'checkIn',
                userName: e.target.id.split(",")[1]
              })
            }
            else if (e.target.name === 'dealClaimed') {
              this.props.GetDealClaimedData(user.BusinessUser.PlaceID, e.target.id.split(",")[0]);
              self.setState({
                modalType: 'dealClaimed',
                userName: e.target.id.split(",")[1]
              })
            }
            this.setState({open: true});
        }
    };

    componentWillReceiveProps(nextProps){
      if(nextProps.checkInDetail)
        this.formateDetail(nextProps.checkInDetail.Result);
    }

    formateDetail=(Detail)=> {
      let checkInDates =[];
      for (let i = 0; i < Detail.length; i++) {
        if (!checkInDates.includes(moment(moment.utc(Detail[i]["CheckInDateTime"]).toDate()).local().format('MM/DD/YYYY'))) {
          checkInDates.push(moment(moment.utc(Detail[i]["CheckInDateTime"]).toDate()).format('MM/DD/YYYY'))
        }
      }
      let dates = [...checkInDates];
      // Detail =
      let DateTime = [];
      let times = [];
      for (let i = 0; i < dates.length; i++) {
          times=[];
        for (let j = 0; j < Detail.length; j++) {
          if (moment(moment.utc(Detail[j]["CheckInDateTime"]).toDate()).local().format('MM/DD/YYYY') === dates[i]) {
            times.push(`${moment(moment.utc(Detail[j]["CheckInDateTime"]).toDate()).local().format('MM/DD/YYYY hh:mm:ss A').split(" ")[1]} ${moment(moment.utc(Detail[j]["CheckInDateTime"]).toDate()).local().format('DD/MM/YYYY hh:mm:ss A').split(" ")[2]}`);
          }
        }
        DateTime.push({date:dates[i],time:times});
      }
      DateTime=this.sortVisitorsModal(DateTime);
      this.setState({DateTime});
    }

    handleClose = () => {
      this.setState({modalType:'',userName:'',open:false,DateTime:[],mpage:0});
    };

    getModalStyle=()=>{
        return {
            borderRadius: '3px',
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
        };
    };

    sortVisitorsModal=(Arr)=>{
    let sortArr=[...Arr];
    // console.log('sortArr',sortArr);
    sortArr.sort((a,b)=>{
      let dateA=new Date(a.date), dateB=new Date(b.date)
      return dateB-dateA //sort by date ascending
    });
    return sortArr;
  }

    sortVisitors=()=>{
      let sortArr=[...this.props.visitors.results.Result];
      sortArr.sort((a,b)=>{
        let dateA=new Date(a.LastCheckInDate);
         let dateB=new Date(b.LastCheckInDate);
        return dateB-dateA //sort by date ascending
      });
      return sortArr;
    }

    render(){
        const { classes,visitors,size=visitors.results.Result.length } = this.props;
        const { rowsPerPage, page ,DateTime,mrowsPerPage,mpage} = this.state;
        let msize=DateTime.length;
        let visitorsData=this.sortVisitors();
       
        const {dealClaimedDetail}=this.props;
        return(
            <div>
                {
                    (!visitors.visitorsReceived) ? <center><Loader/></center>
                        :
                        (!visitors.results.Result.length > 0) ?
                            <div className="no-data">
                                <p><i className="fa fa-exclamation-triangle" aria-hidden="true"/></p>
                                <p className="msg">You don't have any frequent Visitors Yet.</p>
                            </div>
                            :
                            <div style={{minHeight:'38vh'}}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow className={classes.tableRow}>
                                            <TableCell/>
                                            <TableCell numeric className='table-cell'>Last Check In</TableCell>
                                            <TableCell numeric className='table-cell'>Check ins(#)</TableCell>
                                            <TableCell numeric className='table-cell'>Deals Claimed</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {visitorsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((visitor, index) => {
                                           // console.log(visitor,index)
                                            if (index < size)
                                                return (
                                                    <TableRow key={visitor.id} className={classes.tableRow}>
                                                        <TableCell component="th" scope="row" className='table-cell'>
                                                            {visitor.fullname.charAt(0).toUpperCase() + visitor.fullname.substring(1)}
                                                        </TableCell>
                                                        <TableCell className='table-cell'>
                                                          {/*moment(moment.utc(detail[i]["Activitydate"]).toDate()).local().format('MM/DD/YYYY')*/}
                                                            {moment(moment.utc(visitor.LastCheckInDate).toDate()).local().format('MMM Do, YYYY')}
                                                        </TableCell>
                                                        <TableCell numeric className='table-cell'>
                                                            <button onClick={this.handleOpen}
                                                                    id={[visitor.userid, visitor.fullname]}
                                                                    name="checkIn"
                                                                    color={'primary'}
                                                                    className={(visitor.CheckinCount >0 )?classes.btnClickable:classes.btnNormal}
                                                            >
                                                                {visitor.CheckinCount}
                                                            </button>
                                                        </TableCell>
                                                        <TableCell className='table-cell'>
                                                            <button onClick={this.handleOpen}
                                                                    id={[visitor.userid, visitor.fullname]}
                                                                    name="dealClaimed"
                                                                    color={'primary'}
                                                                    className={(visitor.ClaimedCount > 0 )? classes.btnClickable:classes.btnNormal}
                                                            >
                                                                {visitor.ClaimedCount}
                                                            </button>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                        })}
                                    </TableBody>
                                    {
                                        size > 5 &&
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    className={classes.page}
                                                    colSpan={4}
                                                    count={size}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    rowsPerPageOptions={[10, 25]}
                                                    onChangePage={this.handleChangePage}
                                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActionsWrapped}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    }
                                </Table>
                                <Modal
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                    open={this.state.open}
                                    onClose={this.handleClose}
                                >
                                    <div style={this.getModalStyle()} className={this.state.modalType!=='dealClaimed'?"visitors-dilogbox":classes.dealPaper}>
                                        {this.state.modalType !== 'dealClaimed' ? DateTime.length>0 ?
                                            <div>
                                                <Typography variant="title" id="modal-title" className={"visitors-dilogbox".fontSize}>
                                                    <p>{`Check Ins Details for ${this.state.userName && this.state.userName}`}</p>
                                                </Typography>
                                                <Table className={classes.table}>
                                                    <TableHead className={classes.tableRow}>
                                                        <TableRow className={classes.tableRow}>
                                                            <TableCell className="check-in-out-class"><p>Check In Date</p></TableCell>
                                                            <TableCell className="check-in-out-class"><p>Check In Time</p></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(DateTime!==undefined && DateTime.length>0) && DateTime.slice(mpage * mrowsPerPage, mpage * mrowsPerPage + mrowsPerPage).map((d, index) => {
                                                            if (index < msize)
                                                                return (<TableRow className={classes.tableRow}>
                                                                    <TableCell className="visitor-date"><p>{moment(d.date).local().format('MMM Do, YYYY')}</p></TableCell>
                                                                    <TableCell className={classes.time}>{d.time.map((v) => {
                                                                        return <p className="modal-cell">{v}</p>
                                                                    })}</TableCell>
                                                                </TableRow>)
                                                        })}
                                                    </TableBody>
                                                    {
                                                        msize > 2 &&
                                                        <TableFooter className="visitior-table-footer">
                                                            <TableRow>
                                                                <TablePagination
                                                                    colSpan={3}
                                                                    count={msize}
                                                                    rowsPerPage={mrowsPerPage}
                                                                    rowsPerPageOptions={[2, 3, 4, 5 ]}
                                                                    page={this.state.mpage}
                                                                    onChangePage={this.handleModalPageChange}
                                                                    onChangeRowsPerPage={this.handleModalChangeRowsPerPage}
                                                                    ActionsComponent={TablePaginationActionsWrapped}
                                                                />
                                                            </TableRow>
                                                        </TableFooter>
                                                    }
                                                </Table>
                                            </div>
                                          :
                                          <div><Loader/></div>

                                            : dealClaimedDetail ?
                                            <div>
                                                <Typography variant="title" id="modal-title" className={classes.dealTable}>
                                                    {`Check Ins Detail for ${this.state.userName && this.state.userName}`}
                                                </Typography>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={classes.dealTable}>Claimed Date</TableCell>
                                                            <TableCell className={classes.dealTable}>Title</TableCell>
                                                            <TableCell className={classes.dealTable}>Description</TableCell>
                                                            <TableCell className={classes.dealTable}>End Date</TableCell>
                                                            <TableCell className={classes.dealTable}>No of Deals</TableCell>
                                                            <TableCell className={classes.dealTable}>Start Date</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {dealClaimedDetail !== undefined && dealClaimedDetail.Result.map((d) => {
                                                            return (<TableRow>
                                                                <TableCell className={classes.dealTable}>{moment(moment.utc(d.ClaimedDate).toDate()).local().format('MMM Do, YYYY')}</TableCell>
                                                                <TableCell className={classes.dealTable}>{d.Title}</TableCell>
                                                                <TableCell className={classes.dealTable}>{d.Description}</TableCell>
                                                                <TableCell className={classes.dealTable}>{moment(moment.utc(d.EndDate).toDate()).local().format('MMM Do, YYYY')}</TableCell>
                                                                <TableCell className={classes.dealTable}>{d.NumberOfDeals}</TableCell>
                                                                <TableCell className={classes.dealTable}>{moment(moment.utc(d.StartDate).toDate()).local().format('MMM Do, YYYY')}</TableCell>
                                                            </TableRow>)
                                                        })}
                                                    </TableBody>
                                                  {
                                                    <TableFooter>
                                                      <TableRow>
                                                        <TablePagination
                                                          colSpan={3}
                                                          count={msize}
                                                          rowsPerPage={mrowsPerPage}
                                                          rowsPerPageOptions={[2,3, 4, 5 ]}
                                                          page={this.state.mpage}
                                                          onChangePage={this.handleModalPageChange}
                                                          onChangeRowsPerPage={this.handleModalChangeRowsPerPage}
                                                          ActionsComponent={TablePaginationActionsWrapped}
                                                        />
                                                      </TableRow>
                                                    </TableFooter>
                                                  }
                                                </Table>
                                            </div>
                                            :
                                            <div><Loader/></div>}
                                    </div>
                                </Modal>
                            </div>
                }
            </div>
        )
    }
}
const mapStateToProps=(state)=> {
    return {
        visitors:state.visitors,
        user:state.loginResponse.results,
        checkInDetail:state.checkInDetail.results,
        dealClaimedDetail:state.dealClaimedDetail.results
    }
};

const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        fetchVisitorsAction,
      GetCheckInData,
      GetDealClaimedData
    },dispatch)
};

export default connect(mapStateToProps,matchDispatchToProps)(withStyles(styles)(VisitorsTable));